module.exports = __webpack_public_path__ + "img/recent.38475e57.svg";